
import rp252 from "./rp252";
import rp253 from "./rp253";
import rp255 from "./rp255";
import rp254 from "./rp254";

export default {
    rp252,
    rp253,
    rp255,
    rp254
}